"use client";

import { createContext, useContext, useState, useEffect } from "react";

interface CookieConsentContextType {
	hasConsent: boolean;
	setHasConsent: (value: boolean) => void;
	analyticsConsent: boolean;
}

const CookieConsentContext = createContext<
	CookieConsentContextType | undefined
>(undefined);

export function CookieConsentProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [hasConsent, setHasConsent] = useState(false);
	const [analyticsConsent, setAnalyticsConsent] = useState(false);

	useEffect(() => {
		// Check if user has previously given consent
		const consent = localStorage.getItem("cookieConsent");
		if (consent === "true") {
			setHasConsent(true);
			setAnalyticsConsent(true);
		}
	}, []);

	const handleSetConsent = (value: boolean) => {
		setHasConsent(value);
		setAnalyticsConsent(value);
		localStorage.setItem("cookieConsent", value.toString());
	};

	return (
		<CookieConsentContext.Provider
			value={{ hasConsent, setHasConsent: handleSetConsent, analyticsConsent }}
		>
			{children}
		</CookieConsentContext.Provider>
	);
}

export function useCookieConsent() {
	const context = useContext(CookieConsentContext);
	if (context === undefined) {
		throw new Error(
			"useCookieConsent must be used within a CookieConsentProvider"
		);
	}
	return context;
}
